import axios from 'axios';
import React, { useEffect, useState } from 'react';
import config from '../../Config';
import { toast, ToastContainer } from 'react-toastify';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import WebsiteMenu from './WebsiteMenu';

const VoucherSetting = () => {
    document.title = "Print Voucher";

    const AccessKey = localStorage.getItem("AccessKey");
    const UserID = localStorage.getItem("ID");
    const [MemberType] = useState("Website");
    const [loading, setLoading] = useState(false);
    const [ContentPage, setContentPage] = useState({});
    const [voucherEnabled, setVoucherEnabled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const data = {
            AccessKey,
            UserID,
            MemberType,
            ID: 50
        };

        const api_config = {
            method: 'post',
            url: config.base_url + 'ContentPage/GetContentPageByID',
            headers: { 'Content-Type': 'application/json' },
            data
        };

        axios(api_config)
            .then((response) => {
                if (response.data.status_code === 1) {
                    const pageData = response.data.ContentPage;
                    setContentPage(pageData);
                    // Convert ON/OFF string to boolean for switch
                    setVoucherEnabled(pageData.Meta_Keywords?.toLowerCase() === 'on');
                } else {
                    toast.error(response.data.status_message || 'Failed to load content.', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error('Network Error.', { position: toast.POSITION.TOP_RIGHT });
            });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.target;
        if (!form.checkValidity()) {
            e.stopPropagation();
            toast.error('Please fill in all required fields.', {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        setLoading(true);

        const data = {
            AccessKey,
            UserID,
            ID: 50,
            Page_Title: form.startDate.value, // Start date
            Page_Detail: '',
            Meta_Title: form.endDate.value, // End date
            Meta_Description: '',
            Meta_Keywords: voucherEnabled ? 'ON' : 'OFF', // ON/OFF status
            Header_Image: ''
        };

        const api_config = {
            method: 'post',
            url: config.base_url + 'ContentPage/UpdateContentPage',
            headers: { 'Content-Type': 'application/json' },
            data
        };

        axios(api_config)
            .then((response) => {
                if (response.data.status_code === 1) {
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                } else if (response.data.status_message === 'Invalid Access Key.') {
                    navigate('/web-admin/login');
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error('Network Error.', { position: toast.POSITION.TOP_RIGHT });
            });
    };

    return (
        <>
            <ToastContainer />
            <WebsiteMenu />

            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Print Voucher</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Print Voucher</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="page-content">
                        <div className="container">
                            <Form noValidate onSubmit={handleSubmit}>
                                <div className="row align-items-end g-3">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-body p-3">
                                                <div className="row gy-3">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Voucher Start Date</label>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                max="31"
                                                                placeholder="Enter start date (e.g. 5)"
                                                                defaultValue={ContentPage.Page_Title}
                                                                className="form-control"
                                                                required
                                                                name="startDate"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Voucher End Date</label>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                max="31"
                                                                placeholder="Enter end date (e.g. 25)"
                                                                defaultValue={ContentPage.Meta_Title}
                                                                className="form-control"
                                                                required
                                                                name="endDate"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Print Vouchers ON/OFF</label>
                                                            <select
                                                                className="form-select"
                                                                value={voucherEnabled ? 'ON' : 'OFF'}
                                                                onChange={(e) => setVoucherEnabled(e.target.value === 'ON')}
                                                                name="txtMeta_Keywords"
                                                                required
                                                            >
                                                                <option value="ON">ON</option>
                                                                <option value="OFF">OFF</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <button
                                                            type="submit"
                                                            className="button button-primary w-100 mt-4"
                                                            disabled={loading}
                                                        >
                                                            {loading ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VoucherSetting;
